import initializeComponent, { store } from '../react-initialize';
import headerReducer from './reducer';
import Header from './header';
import { initializeNotificationsService } from '../Notifications/notification_service';
import { withBreakpointsContext } from 'core-components';

store.injectReducer('headerState', headerReducer);

initializeNotificationsService();

initializeComponent('Header', withBreakpointsContext(Header));
